import { render, staticRenderFns } from "./FooterTable.vue?vue&type=template&id=1b2313ea&"
import script from "./FooterTable.vue?vue&type=script&lang=js&"
export * from "./FooterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports